export default function filterObjectsByDate(objects, referenceDate = new Date()) {
  const refMonth = referenceDate.getMonth(); // getMonth() returns month from 0-11
  const refDay = referenceDate.getDate(); // getDate() returns day of the month from 1-31

  return objects.filter((obj) => {
    const d = new Date(obj.date);
    const month = d.getMonth();
    const day = d.getDate();

    // Check if the date's month and day are on or before the reference month and day
    return month < refMonth || (month === refMonth && day <= refDay);
  });
}
